if (typeof global === 'undefined') {
  window.global = window;
}

if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = {
    isBuffer: () => false
  };
}

if (typeof window !== 'undefined' && !window.process) {
  window.process = {
    env: {},
    version: '',
    versions: {},
    browser: true
  };
}

/**
 * atob() polyfill to support URL-safe Base64 (RFC 4648 § 5)
 * 
 * JWTs use URL-safe Base64 (- and _ instead of + and /), but native atob()
 * only accepts standard Base64. This polyfill detects and converts automatically.
 * 
 * Required because HMS SDK (@100mslive/react-sdk) uses atob() internally
 * to decode JWT tokens
 */
if (typeof window !== 'undefined' && window.atob) {
  const originalAtob = window.atob;
  
  window.atob = function(str) {
    const isUrlSafe = str.includes('-') || str.includes('_') || (str.length % 4 !== 0);
    
    if (isUrlSafe) {
      let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
      const padding = (4 - (base64.length % 4)) % 4;
      base64 += '='.repeat(padding);
      return originalAtob(base64);
    }
    
    return originalAtob(str);
  };
}
